import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import BreadcrumbBar from "./components/BreadcrumbBar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "./hooks/useLangPath";
import Seo from "./Seo";

function Indices() {
  const { t } = useTranslation();
  const langPath = useLangPath();

  const indices = [
    { label: "NAS100", path: "/indices/nas100-ai-trading-predictions" },
    { label: "UK100",  path: "/indices/uk100-ai-trading-predictions" },
    { label: "US30",   path: "/indices/us30-ai-trading-predictions" },
    { label: "US500",  path: "/indices/us500-ai-trading-predictions" },
    { label: "AU200",  path: "/indices/au200-ai-trading-predictions" },
  ];

  return (
    <>
      <Seo
        title={t("indices.pageTitle")}
        description={t("indices.pageDesc")}
        canonical="/indices"
        breadcrumbs={[
          { name: t("common.home"), path: "/" },
          { name: t("nav.indices"), path: "/indices" },
        ]}
      />
      <BreadcrumbBar crumbs={[{ label: t("common.home"), to: langPath("/") }, { label: t("nav.indices") }]} />
      <Container style={{ paddingTop: 24, paddingBottom: 60 }}>
      <h1>{t("indices.h1")}</h1>
      <p style={{ color: "#6c757d", marginBottom: 32 }}>{t("indices.pageDesc")}</p>
      <Row>
        {indices.map(({ label, path }) => (
          <Col md={4} key={path}>
            <Link to={langPath(path)} className="text-decoration-none">
              <Card className="mb-4"><Card.Body><Card.Title>{label}</Card.Title></Card.Body></Card>
            </Link>
          </Col>
        ))}
      </Row>
      </Container>
    </>
  );
}

export default Indices;
